//------------------------------------------------------------------------------
// コンボボックスヘルパー
//------------------------------------------------------------------------------
/**
 * コンボボックス設定値検索
 *
 * - Autocomplete Field の初期値を設定するために使用する
 *
 * @param {array} options 属性 value と label を持つオブジェクトの配列
 * @param {string} value 設定値
 * @return 属性 value と label を持つオブジェクト
 *        (options に設定値が見つからない場合はヌル)
 */
export function findValue(options, value) {
  return Array.isArray(options)
      ? options.find((option) => option.value === value) ?? null
      : null;
}

// デフォルトエクスポート
export default {
  findValue,
}
